/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/461-lastfm2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5h13c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5zm-2.834 11.887c-2.775 0-3.737-1.25-4.25-2.806l-.513-1.603c-.384-1.172-.834-2.084-2.244-2.084-.978 0-1.972.706-1.972 2.678 0 1.541.784 2.503 1.894 2.503 1.25 0 2.084-.931 2.084-.931l.513 1.394s-.866.85-2.678.85c-2.25 0-3.5-1.313-3.5-3.75 0-2.534 1.25-4.025 3.609-4.025 2.134 0 3.206.769 3.881 2.853l.528 1.603c.384 1.172 1.059 2.022 2.678 2.022 1.091 0 1.669-.241 1.669-.834 0-.466-.272-.803-1.091-.994l-1.091-.256c-1.331-.322-1.859-1.009-1.859-2.1 0-1.747 1.412-2.294 2.853-2.294 1.634 0 2.631.594 2.759 2.038l-1.603.194c-.066-.691-.481-.978-1.25-.978-.706 0-1.137.322-1.137.866 0 .481.209.769.912.931l1.025.225c1.378.322 2.116.994 2.116 2.294 0 1.597-1.347 2.206-3.334 2.206z"/>'
  }
})
